import { getCurrentUser } from '../getCurrentUser/getCurrentUser';
import { getUserPaymentDetails } from '../../../payment';

export const getActiveUserSubscription = (state) => {
  const currentUser = getCurrentUser(state);
  const subscriptions = (currentUser?.subscriptions || []).filter(
    (subscription) => !(subscription?.subscriptionPlan || { zppCertified: false }).zppCertified
  );
  const payableInfos = getUserPaymentDetails(state);

  if (!subscriptions?.length || !payableInfos.active) {
    return null;
  }
  return subscriptions.find((sub) => sub.id === payableInfos.payableId) || null;
};
